import { en as vuetifyEn, he as vuetifyHe } from 'vuetify/locale'

import en from './en'
import he from './he'

export default {
  he: {
    ...he,
    $vuetify: vuetifyHe,
  },
  en: {
    ...en,
    $vuetify: vuetifyEn,
  },
}
